import { render } from "./ModalDeletedQuizPopup.vue?vue&type=template&id=6969a6c0"
import script from "./ModalDeletedQuizPopup.vue?vue&type=script&lang=js"
export * from "./ModalDeletedQuizPopup.vue?vue&type=script&lang=js"

import "./ModalDeletedQuizPopup.vue?vue&type=style&index=0&id=6969a6c0&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__